import React from 'react';
import NewsGrabberSetting from "../../../components/pages/form/Setting/NewsGrabberSetting/NewsGrabberSetting";

const NewsGrabberSettingPage = () => {
    return <NewsGrabberSetting />
};

export default NewsGrabberSettingPage;